export default __webpack_public_path__ + "static/media/solarium.8ed8c55b.svg";